import React, { Component } from 'react'
import { reduxForm, Fields, Field } from 'redux-form'
import { Row, Col, Button, Tabs, Tab } from 'react-bootstrap'
import InputRangeDatePickerDynamicNames from '../comun/form/InputRangeDatePickerDynamicNames'
import InputCheckBox from '../comun/form/InputCheckBox'
import ListadoPage from '../../containers/page/ListadoPage'
import {date_formatter, dateTimeZones, date_parser} from '../../util/formatFunctions'
import InputText from '../comun/form/InputText'
import CircularProgress from '@material-ui/core/CircularProgress'

class FDA extends Component {
  constructor() {
    super()
    this.state = {
      fechaAnalisisDesde: '',
      fechaAnalisisHasta: '',
      fechaAnalisisDesdePool: '',
      fechaAnalisisHastaPool: '',
      customColumns: [],
      listTraits: [],
      stackErrores: [],
      importarAnalisisAPIDisabled: true,
      importarPoolAPIDisabled: true,
      importarSplitsAPIDisabled: true
    }
  }
  
  componentDidMount() {
    document.title = 'Export logs - ' + this.props.t('HEADER.TITLE_GESIPOR')
  }

  componentDidUpdate(prevProps, prevState) {
  }

  exportarArchivos(values) {
    console.log('values',values);
    values.desde = values.desde ?? null;
    values.hasta = values.hasta ?? null;
    this.props.actions.exportarArchivos(values)
  }

  render() {
    const {
      t, handleSubmit 
    } = this.props
    return (
      <div className="content-panel-control">
        <h2 className="page-title">EXPORT LOGS PANEL</h2>
        <div className="clearfix"></div>
        <form className="custom-form" style={{marginTop: '20px'}}>
          <Row>
            <Col sm={12}>   
              <Row> 
                <Col sm={12}><h4><b>Period</b></h4></Col>
                <Fields
                  names={['desde', 'hasta']}
                  component={InputRangeDatePickerDynamicNames}
                  colSm={4}
                  nameFrom="desde"
                  nameTo="hasta"                                               
                />
              </Row> 
              <div style={{marginTop: '20px'}}></div>             
              <h4><b>Reports to export</b></h4>
              <Col sm={6}>
                <Col sm={6} style={{paddingTop: '20px'}}>              
                  <Field
                    id="analysis"
                    name="analysis"
                    colSm={12}
                    inline
                    component={InputCheckBox}
                    claseActivo="onoffswitch-label"
                    controlLabel="Analysis"
                  />
                  <Field
                    id="dilution"
                    name="dilution"
                    colSm={12}
                    inline
                    component={InputCheckBox}
                    claseActivo="onoffswitch-label"
                    controlLabel="Dilution"
                  />
                  <Field
                    id="pools"
                    name="pools"
                    colSm={12}
                    inline
                    component={InputCheckBox}
                    claseActivo="onoffswitch-label"
                    controlLabel="Pools"
                  />
                  <Field
                    id="packaging"
                    name="packaging"
                    colSm={12}
                    inline
                    component={InputCheckBox}
                    claseActivo="onoffswitch-label"
                    controlLabel="Packaging"
                  />
                  <Field
                    id="pictraq"
                    name="pictraq"
                    colSm={12}
                    inline
                    component={InputCheckBox}
                    claseActivo="onoffswitch-label"
                    controlLabel="PicTraq (importation date)"
                  />
                </Col>
                <Col sm={6} style={{height: '120px', paddingTop: '20px'}}>
                  <Field
                    id="boars"
                    name="boars"
                    colSm={12}
                    inline
                    component={InputCheckBox}
                    claseActivo="onoffswitch-label"
                    controlLabel="Boars"
                  />
                  <Field
                    id="customers"
                    name="customers"
                    colSm={12}
                    inline
                    component={InputCheckBox}
                    claseActivo="onoffswitch-label"
                    controlLabel="Customers"
                  />
                  <Field
                    id="orders"
                    name="orders"
                    colSm={12}
                    inline
                    component={InputCheckBox}
                    claseActivo="onoffswitch-label"
                    controlLabel="Orders"
                  />
                  <Field
                    id="controlpanel"
                    name="controlpanel"
                    colSm={12}
                    inline
                    component={InputCheckBox}
                    claseActivo="onoffswitch-label"
                    controlLabel="Control Panel"
                  />
                  <Field
                    id="users"
                    name="users"
                    colSm={12}
                    inline
                    component={InputCheckBox}
                    claseActivo="onoffswitch-label"
                    controlLabel="Users"
                  />
                </Col>
                <div className="clearfix"></div>
                <hr/>
                <div className="botones-acciones-panel">                
                  <Button
                    type="button"                                
                    className={"btn btn-primary"} 
                    onClick={handleSubmit(this.exportarArchivos.bind(this))}                 
                  >Export files</Button>
                </div>
              </Col>              
            </Col>            
          </Row>
        </form>
      </div>
    )
  }
}

export default (reduxForm({
  form: 'formFDA',
})(FDA))